export class ConsentSystemResponse {
  private constructor(
    public readonly status: 'initialized' | 'not-initialized',
    public readonly hasAbTestingConsent: boolean,
    public readonly notInitializedReason?: string
  ) {}

  public static createConsentSystemInitializedResponse(hasAbTestingConsent: boolean): ConsentSystemResponse {
    return new ConsentSystemResponse('initialized', hasAbTestingConsent);
  }

  public static createConsentSystemNotInitializedResponse(reason: string): ConsentSystemResponse {
    return new ConsentSystemResponse('not-initialized', false, reason);
  }
}
